// extracted by mini-css-extract-plugin
export var backVideo = "works-module--backVideo--2y0uk";
export var backVideoActive = "works-module--backVideoActive--2UWvr";